// English translations for the stock page (French string -> English).
const m: Record<string, string> = {
  // ── Page chrome ──
  'Stock': 'Stock',
  'Atelier — matières premières, découpe, recette d’album & rentabilité': 'Workshop — raw materials, cutting, album recipe & profitability',
  'Scanner un ticket': 'Scan a receipt',
  'Article': 'Item',
  'Nouvel achat': 'New purchase',

  // ── Snapshot strip ──
  'Valeur du stock': 'Stock value',
  'Articles suivis': 'Tracked items',
  'Stock bas': 'Low stock',

  // ── Low-stock alerts ──
  'Stock bas — à racheter': 'Low stock — reorder',
  '{n} bas': '{n} low',
  'min': 'min',
  'délai {n} j': 'lead time {n} d',

  // ── Section 1: raw materials ──
  'Matières premières': 'Raw materials',
  'Tout ce que l’atelier garde en stock — matières d’album et fournitures.': 'Everything the workshop keeps in stock — album materials and supplies.',
  'Aucun article — créez le premier avec « + Article ».': 'No items — create the first one with “+ Item”.',
  'Fourniture': 'Supply',
  'Consommable': 'Consumable',
  '{n} album(s)': '{n} album(s)',
  'sous le min ({qty} {unit})': 'below min ({qty} {unit})',
  'Ajuster': 'Adjust',
  'Atelier': 'Workshop',

  // ── Section 2: transformation & cutting ──
  'Transformation & découpe': 'Transformation & cutting',
  'Économie de la découpe : ce qu’on achète → ce qu’on en tire → le coût par unité consommée. (La découpe se modifie dans la fiche article.)': 'Cutting economics: what we buy → what we get from it → the cost per consumed unit. (Edit cutting in the item form.)',
  'Aucune matière avec découpe — ajoutez le rendement dans la fiche d’un article.': 'No material with cutting — add the yield in an item’s form.',
  'Modifier la découpe': 'Edit cutting',
  'Pièce :': 'Piece:',
  'Coût / {unit}': 'Cost / {unit}',

  // ── Cutting calculator presets ──
  'Planche (avant/arrière) 216×303': 'Board (front/back) 216×303',
  'Dos 10×303': 'Spine 10×303',
  'Kit album (4 planches doublées + 2 dos)': 'Album kit (4 doubled boards + 2 spines)',
  'Vinyle couverture 483×329': 'Cover vinyl 483×329',
  'Feuille intérieur A3 297×420': 'Inner sheet A3 297×420',
  'Page de garde A3 420×297': 'Endpaper A3 420×297',
  'Personnalisé…': 'Custom…',

  // ── Material modal ──
  'Modifier — {name}': 'Edit — {name}',
  'Nouvel article': 'New item',
  'Article désactivé.': 'Item deactivated.',
  'Décrivez le matériau (ou la correction) — l’IA remplit le formulaire (vous validez)': 'Describe the material (or the correction) — AI fills the form (you confirm)',
  'Décrivez le matériau — l’IA remplit le formulaire (vous validez)': 'Describe the material — AI fills the form (you confirm)',
  'ex. « plaque carton gris 2mm 100×80cm à 30dh pour les planches d’album »': 'e.g. “2mm grey cardboard sheet 100×80cm at 30 MAD for album boards”',
  'Remplir': 'Fill',
  'Prix détecté :': 'Detected price:',
  'unité': 'unit',
  'saisissez-le lors du premier': 'enter it at the first',
  'achat': 'purchase',
  '(le coût moyen suit les achats réels).': '(average cost follows actual purchases).',
  'Nom de l’article': 'Item name',
  'Plaque rigide, carton, colle…': 'Rigid board, cardboard, glue…',
  'Classe': 'Class',
  'Album = compte dans le coût d’album ; Atelier = fourniture générale': 'Album = counts in album cost; Workshop = general supply',
  'Matière d’album': 'Album material',
  'Fourniture atelier': 'Workshop supply',
  'Type': 'Type',
  'Consommable = déduit par album (recette)': 'Consumable = deducted per album (recipe)',
  'Consommable d’album': 'Album consumable',
  'Fourniture / outil': 'Supply / tool',
  'Délai de réappro (jours)': 'Reorder lead time (days)',
  'ex. 3': 'e.g. 3',
  'Découpe — comment on achète vs comment on consomme': 'Cutting — how we buy vs how we consume',
  'Unité d’achat': 'Purchase unit',
  'ex. plaque 100×80, pot, boîte': 'e.g. sheet 100×80, jar, box',
  'Unité de consommation': 'Consumption unit',
  'ex. kit album, dose, carton': 'e.g. album kit, dose, board',
  'Calculateur — entrez la taille de la plaque achetée, on calcule le rendement': 'Calculator — enter the size of the purchased sheet, we compute the yield',
  'Largeur (mm)': 'Width (mm)',
  'Hauteur (mm)': 'Height (mm)',
  'Pièce découpée': 'Cut piece',
  'Largeur pièce (mm)': 'Piece width (mm)',
  'Hauteur pièce (mm)': 'Piece height (mm)',
  '{p} planches → {k} kit(s) (planches doublées ×2, dos dans les chutes)': '{p} boards → {k} kit(s) (boards doubled ×2, spines from offcuts)',
  '{p} pièce(s) de {w}×{h} mm': '{p} piece(s) of {w}×{h} mm',
  'Utiliser :': 'Use:',
  'plaque': 'sheet',
  '1 {pu} = combien de {cu} ?': '1 {pu} = how many {cu}?',
  'unité d’achat': 'purchase unit',
  'unités': 'units',
  'Le rendement de découpe — calculé ci-dessus ou saisi à la main': 'The cutting yield — computed above or entered manually',
  'Coût moyen': 'Average cost',
  'Stock min': 'Min stock',
  'Alerte en-dessous': 'Alert below this',
  'Stock max': 'Max stock',
  'Notes': 'Notes',
  'Fournisseur, référence…': 'Supplier, reference…',
  'Supprimer « {name} » ? Les mouvements et la ligne de recette liés seront supprimés aussi.': 'Delete “{name}”? The linked movements and recipe line will be deleted too.',
  'Créer l’article': 'Create item',

  // ── Adjust modal ──
  'Ajuster — {name}': 'Adjust — {name}',
  'Stock actuel :': 'Current stock:',
  'Entrée': 'In',
  'Sortie': 'Out',
  'Quantité ({unit})': 'Quantity ({unit})',
  'Raison': 'Reason',
  'Ajustement (comptage)': 'Adjustment (count)',
  'Perte / chute': 'Loss / scrap',
  'Note (optionnel)': 'Note (optional)',
  'ex. inventaire du 10/06': 'e.g. inventory of 06/10',

  // ── Purchase modal ──
  'Fournisseur (optionnel)': 'Supplier (optional)',
  'Note': 'Note',
  'Prix / {unit} (MAD)': 'Price / {unit} (MAD)',
  'entrée de': 'in of',
  'à': 'at',
  'Ajouter une ligne': 'Add a line',
  'Total :': 'Total:',
  'Valider l’achat': 'Confirm purchase',

  // ── Recipe card ──
  'Recette d’un album': 'Album recipe',
  'Coût matières réel, à {n} pages. Chaque album consomme : quantité fixe + quantité × pages. À l’« Imprimée », chaque commande déduit automatiquement (recette × nb d’albums).': 'Real material cost, at {n} pages. Each album consumes: fixed quantity + quantity × pages. At “Printed”, each order is deducted automatically (recipe × number of albums).',
  'Coût matières vrai / album': 'True material cost / album',
  'à {n} pages': 'at {n} pages',
  'fixe': 'fixed',
  '+ × pages': '+ × pages',
  'Retirer de la recette': 'Remove from recipe',
  'Aucune matière dans la recette — ajoutez un consommable d’album ci-dessous.': 'No material in the recipe — add an album consumable below.',
  'Ajouter un consommable…': 'Add a consumable…',
  'Simulation pages :': 'Page simulation:',
  'Enregistrer la recette': 'Save recipe',

  // ── Order profitability ──
  'Rentabilité par commande': 'Profitability per order',
  'Bénéfice estimé d’une commande : CA − matières − emballage − livraison − redo.': 'Estimated order profit: revenue − materials − packaging − delivery − redo.',
  'N° de commande Shopify (ex. 1076)': 'Shopify order no. (e.g. 1076)',
  'Calculer': 'Calculate',
  'Commande introuvable.': 'Order not found.',
  'Entrez un numéro pour voir la marge. Le détail complet figure aussi sur la fiche commande.': 'Enter a number to see the margin. The full breakdown is also on the order page.',
  '{n} p.': '{n} p.',
  'Chiffre d’affaires': 'Revenue',
  'Matières ({cost} × {n})': 'Materials ({cost} × {n})',
  'Emballage': 'Packaging',
  'Livraison': 'Delivery',
  'estimée': 'estimated',
  'Réimpression / redo': 'Reprint / redo',
  'Coût total': 'Total cost',
  'Bénéfice': 'Profit',

  // ── Recent purchases & movements ──
  'Achats récents': 'Recent purchases',
  'Achat': 'Purchase',
  'Annuler cet achat (le stock est re-déduit)': 'Cancel this purchase (stock is re-deducted)',
  'Annuler cet achat ? Les entrées de stock correspondantes seront retirées.': 'Cancel this purchase? The corresponding stock entries will be removed.',
  'Aucun achat enregistré.': 'No purchase recorded.',
  'Derniers mouvements': 'Latest movements',
  'Commande': 'Order',
  'Ajustement': 'Adjustment',
  'Perte': 'Loss',
  'Aucun mouvement.': 'No movement.',

  // ── Receipt intake modal ──
  'Scanner un ticket fournisseur': 'Scan a supplier receipt',
  'Prenez en photo le ticket / bon d’achat du fournisseur. L’IA lit les articles, puis': 'Photograph the supplier’s receipt / purchase order. The AI reads the items, then',
  'vous validez chaque ligne': 'you confirm each line',
  'avant d’ajouter au stock — rien n’est enregistré automatiquement.': 'before adding to stock — nothing is saved automatically.',
  'Lecture du ticket en cours…': 'Reading the receipt…',
  'Prendre une photo / choisir une image': 'Take a photo / choose an image',
  'L’IA analyse l’image…': 'The AI is analyzing the image…',
  'Fournisseur': 'Supplier',
  'Nom du fournisseur': 'Supplier name',
  'Date d’achat': 'Purchase date',
  'Vérifiez chaque ligne. Pour chaque article : rapprochez-le d’un article existant, ou créez-en un nouveau (album / business).': 'Review each line. For each item: match it to an existing item, or create a new one (album / business).',
  'Ticket :': 'Receipt:',
  '(vide)': '(empty)',
  'Retirer cette ligne': 'Remove this line',
  'Quantité': 'Quantity',
  'Prix unitaire (MAD)': 'Unit price (MAD)',
  'Article de stock': 'Stock item',
  'Créer un nouvel article': 'Create a new item',
  'Nom du nouvel article': 'New item name',
  'Album (entre dans le coût)': 'Album (counts in cost)',
  'Business (suivi seul)': 'Business (tracking only)',
  'Aucune ligne détectée — réessayez avec une photo plus nette.': 'No line detected — try again with a sharper photo.',
  'Ajouter une ligne manuellement': 'Add a line manually',
  'Reprendre une photo': 'Retake a photo',
  'Valider et ajouter au stock': 'Confirm and add to stock',
};
export default m;
